import { render, staticRenderFns } from "./ValidateView.vue?vue&type=template&id=8ef5ff50"
import script from "./ValidateView.vue?vue&type=script&lang=js"
export * from "./ValidateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports